import Vue from 'vue'
import Vuex from 'vuex'
import detailStrict from './modules/detail-strict'
import secret from './modules/secret-filter'
import newOnePrice from './modules/new-one-price'
import filterQuick from './modules/filter-quick'
import newFilterComp from './modules/new-filter-comp'
import realDealPrice from './modules/real-deal-price'
import mine from './modules/mine'
import videoFilter from './modules/video-filter'

Vue.use(Vuex)

const temp = [secret]
let state = {}
let getters = {}
let mutations = {}

temp.forEach((item) => {
  state = Object.assign(state, item.state)
  getters = Object.assign(getters, item.getters)
  mutations = Object.assign(mutations, item.mutations)
})

export default new Vuex.Store({
  modules: {
    detailStrict,
    newOnePrice,
    filterQuick,
    newFilterComp,
    realDealPrice,
    mine,
    videoFilter
  },
  state,
  getters,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})
